import { Model } from "../model";
import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";


export class UserEngagementModel extends Model implements IModel<UserEngagementModel> {
  userName: string = "";
  domainName: string = "";
  companyGroupId: string = "";
  screen: string = "";
  dateTime: string = "";
  browser: string = "";
  os: string = "";
  url: string = "";
  amountAccess: number = 0;
  topScreen: string = "";

  static create(input: any): UserEngagementModel {
    return ObjectMapper.deserialize<UserEngagementModel>(UserEngagementModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}